/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import Button from '@material-ui/core/Button';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import AddNewManufacturerForm from './AddNewManufacturerForm';
import AddNewManufacturerSuccess from './AddNewManufacturerSuccess';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewManufacturer extends React.Component<*> {
  @observable vModelData = this.props.model;

  @observable vChildModelData = this.props.childmodel;

  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const fields: Array<Object> = [
      {
        name: 'addManufacturerForm',
        label: t('general:actions.new_manufacturer'),
        title: 'New Manufacturer',
        fields: [
          {
            name: 'tradingAccount',
            label: t('general:trading_account'),
            rules: 'required|string',
            disabled: Boolean(parentForm.$('chooseAccount.tradingAccount').extra.selectID),
            value: parentForm.$('chooseAccount.tradingAccount').extra.selectID,
          },
          {
            name: 'manufacturer',
            label: t('general:manufacturer'),
            rules: 'required|string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { tradingAccount, manufacturer }: Object = data.values().addManufacturerForm;

        actionDrawerStore.userAddManufacturer({
          account_id: tradingAccount, //parentForm.$('chooseAccount.tradingAccount').value,
          name: manufacturer,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'New Manufacturer',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const model: Object = this.props.model;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.create_new_manufacturer')} />
          <div className={styles['action-drawer-content']}>
            {actionDrawerStore.errorResponse.message}
          </div>
          <div className={styles['action-drawer-actions']}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => actionDrawerStore.closeActionDrawer()}
            >
              {t('general:actions.close')}
            </Button>
          </div>
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <AddNewManufacturerSuccess
          parentForm={parentForm}
          model={this.props.model}
          childmodel={this.props.childmodel}
        />
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.create_new_manufacturer')} />
        <AddNewManufacturerForm form={this.createForm()} accountsModel={this.props.accountsModel} />
      </div>
    );
  }
}
